import { createSlice } from "@reduxjs/toolkit";

export const AuthSlice = createSlice({
  name: "auth",
  initialState: { email: "", otp: null, username: "", userId: "", token: "" },
  reducers: {
    setEmail: (state, action) => {
      const { payload } = action;
      state.email = payload;
    },
    setOTP: (state, action) => {
      const { payload } = action;
      state.otp = payload;
    },
    signin: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        otp: null,
        ...payload,
      };
    },
  },
});

export default AuthSlice.reducer;
